module.exports = __webpack_public_path__ + "static/template-square-b668f6399c63f45f85448f67b6cd25a7.png";